import React, { useEffect, useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { usePageHeaderContext } from './pageHeaderContext';

const readTitle = (children) => React.Children.toArray(children)
    .map((child) => typeof child === 'string' || typeof child === 'number' ? String(child) : '')
    .join('')
    .trim();

const PageHeader = ({ children, icon: IconOverride = null }) => {
    const location = useLocation();
    const { setPageHeader } = usePageHeaderContext();
    const title = useMemo(() => readTitle(children), [children]);

    useEffect(() => {
        if (!title) return undefined;

        setPageHeader({
            icon: IconOverride,
            pathname: location.pathname,
            title
        });

        return undefined;
    }, [IconOverride, location.pathname, setPageHeader, title]);

    return null;
};

export default PageHeader;
